import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./navbar.module.css";
const Navbar = (props) => {
  const { active } = props;
  const [nav, setNav] = useState(false);
  const toggleNav = () => {
    setNav((nav) => !nav);
  };
  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>Safe Notes</div>
      <div className={nav ? `${styles.activeNav}` : `${styles.navs}`}>
        <Link to="/" className={active === "1" ? `${styles.active}` : null}>
          Home
        </Link>
        <Link
          to="/checklist"
          className={active === "2" ? `${styles.active}` : null}
        >
          Links
        </Link>
        <Link
          to="/notes"
          className={active === "3" ? `${styles.active}` : null}
        >
          Notes
        </Link>
        <Link
          to="/passwords"
          className={active === "4" ? `${styles.active}` : null}
        >
          Passwords
        </Link>
      </div>
      <div className={styles.menu} onClick={toggleNav}>
        <i className="fa-solid fa-bars"></i>
      </div>
    </nav>
  );
};

export default Navbar;
